import {createSlice} from "@reduxjs/toolkit";


const UserInfoSlice = createSlice({
    name: "UserInfoSlice",
    initialState: {
        name: null,
        surname: null,
        phone: null,
        country: null,
        region: null,
        city: null,
        address: null
    },
    reducers: {
        setUserData(state, action) {
            state.name = action.payload.name;
            state.surname = action.payload.surname;
            state.phone = action.payload.phone;
            state.country = action.payload.country;
            state.region = action.payload.region;
            state.city = action.payload.city;
            state.address = action.payload.address;
        }
    }
})


export const {setUserData} = UserInfoSlice.actions;

export default UserInfoSlice.reducer;